export default __webpack_public_path__ + "alberta-history.b39c5233a2769fc1cdcb.svg";